import React from 'react';
import { books } from '../data/mock';
import BookCard from './BookCard';

const BookShowcase = () => {
  return (
    <section className="book-showcase" id="books">
      <div className="section-noise" />
      
      <div className="showcase-header">
        <h2 className="section-title">CATALOG</h2>
        <div className="title-underline" />
      </div>
      
      <div className="books-grid">
        {books.map((book) => (
          <BookCard key={book.id} book={book} />
        ))}
      </div>
    </section>
  );
};

export default BookShowcase;
